import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import logo from "../img/log.png";
import "../css/Navbar.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const Navbar = () => {
  const location = useLocation();

  // Detect if About or ITI submenu is active
  const isAboutActive = ["/about", "/history", "/infrastructure"].includes(location.pathname);
  const isITIActive = ["/ouriti", "/courses", "/placements"].includes(location.pathname);

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white shadow sticky-top p-0">
      {/* Logo */}
      <Link to="/" className="navbar-brand d-flex align-items-center px-4 px-lg-5">
        <img
          src={logo}
          alt="eLearning Logo"
          className="logo-img"
          style={{ height: "85px", width: "auto" }}
        />
      </Link>

      {/* Mobile Toggle */}
      <button
        className="navbar-toggler me-4"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
        aria-controls="navbarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      {/* Navbar Menu */}
      <div className="collapse navbar-collapse" id="navbarCollapse">
        <div className="navbar-nav ms-auto p-4 p-lg-0">

          {/* Home */}
          <NavLink to="/" end className="nav-item nav-link">
            Home
          </NavLink>

          {/* About Us Dropdown */}
          <div className="nav-item dropdown">
            <span
              className={`nav-link dropdown-toggle ${isAboutActive ? "active" : ""}`}
              id="aboutDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              About Us <i className="fa fa-chevron-down ms-1 small dropdown-arrow"></i>
            </span>
            <ul className="dropdown-menu fade-down" aria-labelledby="aboutDropdown">
              <li>
                <NavLink to="/visionmission" className="dropdown-item">
                  Our Vision & Mission
                </NavLink>
              </li>
              <li>
                <NavLink to="/history" className="dropdown-item">
                  History
                </NavLink>
              </li>
              <li>
                <NavLink to="/infrastructure" className="dropdown-item">
                  Infrastructure
                </NavLink>
              </li>
            </ul>
          </div>

          {/* ITI Dropdown */}
          <div className="nav-item dropdown">
            <span
              className={`nav-link dropdown-toggle ${isITIActive ? "active" : ""}`}
              id="itiDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              ITI <i className="fa fa-chevron-down ms-1 small dropdown-arrow"></i>
            </span>
            <ul className="dropdown-menu fade-down" aria-labelledby="itiDropdown">
              <li>
                <NavLink to="/about" className="dropdown-item">
                  About ITI
                </NavLink>
              </li>
              <li>
                <NavLink to="/Projectdisplay" className="dropdown-item">
                  Project
                </NavLink>
              </li>
              <li>
                <NavLink to="/admission" className="dropdown-item">
                  Addmision
                </NavLink>
              </li>
            </ul>
          </div>

          {/* Other Pages */
          }<NavLink to="/coursesoffered" className="nav-item nav-link">
            Courses
          </NavLink>
          <NavLink to="/staffdetails" className="nav-item nav-link">
            Staffs
          </NavLink>
          <NavLink to="/gallery" className="nav-item nav-link">
            Gallery
          </NavLink>
          <NavLink to="/contact" className="nav-item nav-link">
            Contact
          </NavLink>
        </div>

        {/* Login Button */}
        <Link
          to="/login"
        >
          <i className="fa fa-user me-2"></i>
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
